import { useMutation } from "@vue/apollo-composable";
import { gqlOutcome } from "@/api/client";
import { TransferDocument, TransferStatus } from "@/api/generated/graphql";

export async function makeTransfer({
  fromAccountId,
  toAccountId,
  amount,
  description,
  toAccountIsLoan,
}: {
  fromAccountId: string;
  toAccountId: string;
  amount: number;
  description: string;
  toAccountIsLoan?: boolean;
}): Promise<{
  id: string;
  dateTime: Date;
  outcome: TransferStatus;
}> {
  const { onDone, onError, mutate } = useMutation(TransferDocument);
  const resFuture = new Promise<{
    id: string;
    dateTime: Date;
    outcome: TransferStatus;
  }>((resolve, reject) => {
    onDone(result => {
      const transferResult = result.data?.transfer;
      if (transferResult?.outcome !== gqlOutcome.ACCEPTED) {
        reject(new Error(transferResult?.outcome ?? "No outcome"));
      } else if (!transferResult?.id) {
        reject(new Error("No id for created transfer"));
      } else if (!transferResult?.dateTime) {
        reject(new Error("No date for created transfer"));
      }

      resolve({
        id: transferResult!.id!,
        dateTime: transferResult!.dateTime!,
        outcome: transferResult!.outcome!,
      });
    });
    onError(error => {
      reject(error);
    });
  });

  await mutate({
    fromAccount: fromAccountId,
    toAccount: toAccountId,
    amount: amount,
    description: description,
    toAccountIsLoan: toAccountIsLoan,
  });

  return resFuture;
}
